import React from "react";
import { Image } from "semantic-ui-react";

export default function ShareButton({ onClick }) {
  return (
    <button className="share-button" onClick={onClick}>
      <Image
        style={{ height: "35px", width: "35px" }}
        src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/share_icons/sharebtn.png`}
        alt="Share icon"
      />
      Share this page
    </button>
  );
}
